var map = {
	"./audio_logo.png": 904,
	"./doc_logo.png": 124,
	"./excel_logo.png": 369,
	"./img_logo.png": 437,
	"./login.png": 113,
	"./logo.png": 153,
	"./logos/1/logo.png": 186,
	"./logos/2/logo.png": 271,
	"./pdf_logo.png": 252,
	"./video_logo.png": 949,
	"./word_logo.png": 828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;